module.exports = __webpack_public_path__ + "img/gift-17-c1.5696bb37.png";